import { getMyProgress, getMyWeekProgress, getScoresTimeLine } from '../api/stats';
import { getKssData } from './kssData';
import { getKssTrackerData } from './kssTracker';

export async function updateScoreAtoms(
    setUserKssData,
    setKssTrackerData,
    setProgressData,
    setWeekProgressData,
    setTimeLineData,
) {
    const kssPromise = getKssData()
        .then((kssData) => {
            setUserKssData(kssData);
        })
        .catch((error) => {
            console.error('Ошибка получения КСС', error);
        });

    let kssTrackerPromise;

    try {
        kssTrackerPromise = getKssTrackerData
            .then((kssTrackerData) => {
                setKssTrackerData(kssTrackerData);
            })
            .catch((error) => {
                console.error('Ошибка получения КСС для трекера', error);
            });
    } catch (err) {
        console.error('Ошибка получения КСС для трекера', err);
    }

    const progressPromise = getMyProgress()
        .then(({ data }) => {
            setProgressData(data);
        })
        .catch((err) => {
            console.error('Ошибка получения прогресса', err);
        });

    const weekProgressPromise = getMyWeekProgress()
        .then(({ data }) => {
            setWeekProgressData(data);
        })
        .catch((err) => {
            console.error('Ошибка получения данных о недельном прогрессе', err);
        });

    const timelinePromise = getScoresTimeLine()
        .then(({ data }) => {
            if (data?.periods?.length === 0) {
                return [];
            }
            setTimeLineData(data);
        })
        .catch((err) => {
            console.error('Ошибка получения данных о недельном прогрессе', err);
        });

    return Promise.allSettled([kssPromise, kssTrackerPromise, progressPromise, weekProgressPromise, timelinePromise]);
}
